module.exports = __webpack_public_path__ + "img/bottom.d658dace.jpg";